import { render, staticRenderFns } from "./r-map-addon-group-page.vue?vue&type=template&id=91c7d9fe"
import script from "./r-map-addon-group-page.vue?vue&type=script&lang=js"
export * from "./r-map-addon-group-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91c7d9fe')) {
      api.createRecord('91c7d9fe', component.options)
    } else {
      api.reload('91c7d9fe', component.options)
    }
    module.hot.accept("./r-map-addon-group-page.vue?vue&type=template&id=91c7d9fe", function () {
      api.rerender('91c7d9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-addon/group/r-map-addon-group-page.vue"
export default component.exports